export enum SSOMethod {
    JWT = 'jwt',
    OAUTH = 'oauth',
}